module.exports = __webpack_public_path__ + "static/media/dincondensed-bold-webfont.8be0c90d.woff2";